module.exports = {"LIQUIDITY_ACCOUNTS":{"WARNING":{"NO_ACCOUNTS":"Sorry! There aren't any accounts. You can add the first!"},"TABLE_COLUMN":{"ID":"ID","NAME":"Name","NUMBER":"Number","BALANCE":"Balance","CURRENCY":"Currency","IBAN":"IBAN","REFILL_DATE":"Last refill date"},"EDIT":{"SELECT_TITLE":"Select liquidity account"},"MODAL":{"HEADER":"Change liquidity account","BODY":{"DESCRIPTION":"To change the liquidity pool of this transactions select it from the list below. Be aware that this action can not be undone."}}}}


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/core/translate/translations/en/liquidity_accounts.json
// module id = 698
// module chunks = 0